enum UserRole {
    SUPER_ADMIN = 4,
    ADMIN = 3,
    CONTROLLER = 2,
    REPRESENTATIVE = 1,
    MANAGER = 5
}

export default UserRole